module.exports = __webpack_public_path__ + "img/35-Growing slowly.31704a34.png";